import { render, staticRenderFns } from "./ImplantExport.vue?vue&type=template&id=97c9173e"
import script from "./ImplantExport.vue?vue&type=script&lang=js"
export * from "./ImplantExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports